const FETCH_NOTIFICATION_EVENT_REQUEST = 'FETCH_NOTIFICATION_EVENT_REQUEST';
const FETCH_NOTIFICATION_EVENT_SUCCESS = 'FETCH_NOTIFICATION_EVENT_SUCCESS';
const FETCH_NOTIFICATION_EVENT_ERROR = 'FETCH_NOTIFICATION_EVENT_ERROR';
const ADD_COMM_PROFILE_REQUEST = 'ADD_COMM_PROFILE_REQUEST';
const ADD_COMM_PROFILE_SUCCESS = 'ADD_COMM_PROFILE_SUCCESS';
const ADD_COMM_PROFILE_ERROR = 'ADD_COMM_PROFILE_ERROR';
const FETCH_COMM_PROFILE_REQUEST = 'FETCH_COMM_PROFILE_REQUEST';
const FETCH_COMM_PROFILE_SUCCESS = 'FETCH_COMM_PROFILE_SUCCESS';
const FETCH_COMM_PROFILE_ERROR = 'FETCH_COMM_PROFILE_ERROR';
const UPDATE_COMM_PROFILE_REQUEST = 'UPDATE_COMM_PROFILE_REQUEST';
const UPDATE_COMM_PROFILE_SUCCESS = 'UPDATE_COMM_PROFILE_SUCCESS';
const UPDATE_COMM_PROFILE_ERROR = 'UPDATE_COMM_PROFILE_ERROR';
const HIDE_COMM_PROFILE_LOADER = 'HIDE_COMM_PROFILE_LOADER';
const SHOW_COMM_PROFILE_LOADER = 'SHOW_COMM_PROFILE_LOADER';

export {
    FETCH_NOTIFICATION_EVENT_REQUEST,
    FETCH_NOTIFICATION_EVENT_SUCCESS,
    FETCH_NOTIFICATION_EVENT_ERROR,
    ADD_COMM_PROFILE_REQUEST,
    ADD_COMM_PROFILE_SUCCESS,
    ADD_COMM_PROFILE_ERROR,
    FETCH_COMM_PROFILE_REQUEST,
    FETCH_COMM_PROFILE_SUCCESS,
    FETCH_COMM_PROFILE_ERROR,
    UPDATE_COMM_PROFILE_REQUEST,
    UPDATE_COMM_PROFILE_SUCCESS,
    UPDATE_COMM_PROFILE_ERROR,
    HIDE_COMM_PROFILE_LOADER,
    SHOW_COMM_PROFILE_LOADER,
};
